import React from 'react'
import Main from '../../../../components/HOC/Main'
import { NAVIGATION } from '../../../../lib/navigation'
import TeamMemberForm from '../../../../components/pages/TeamMemberForm'

const AddTeamMemberPage = () => {
    return (
        <Main crumbs={[{ title: "masters" }, { title: "team members", href: NAVIGATION.INNER_NAVIGATION.MASTERS.TEAM_MEMBERS }, { title: "Add team member" }]}>
            <TeamMemberForm />
        </Main>
    )
}

export default AddTeamMemberPage